(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '../svg/CircleCheck', '../styles/colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('../svg/CircleCheck'), require('../styles/colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.CircleCheck, global.colors);
    global.CircleCheckIcon = mod.exports;
  }
})(this, function (exports, _react, _CircleCheck, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _CircleCheck2 = _interopRequireDefault(_CircleCheck);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  // FIXME may want to delete this component
  var CircleCheckIcon = function CircleCheckIcon() {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_CircleCheck2.default, { size: '32', fill: _colors2.default.tomato }),
      _react2.default.createElement(_CircleCheck2.default, { size: '24', fill: _colors2.default.jungle }),
      _react2.default.createElement(_CircleCheck2.default, { size: '16', fill: _colors2.default.dragon })
    );
  };

  exports.default = CircleCheckIcon;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/elements/CircleCheckIcon.js
// module id = 529
// module chunks = 0